module.exports = __webpack_public_path__ + "img/banner-bg.3f8f7d15.jpg";